/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Quarter_ShortInputs */

const th_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Q${i?.n}`)
};

const en_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Q${i?.n}`)
};

const ja_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第${i?.n}Q`)
};

const zh_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第${i?.n}节`)
};

const es_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`C${i?.n}`)
};

const pt_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Q${i?.n}`)
};

const id_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`K${i?.n}`)
};

const fr_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`QT${i?.n}`)
};

const tl_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Q${i?.n}`)
};

const vi_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`H${i?.n}`)
};

const ko_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}Q`)
};

const de_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`V${i?.n}`)
};

const ru_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ч${i?.n}`)
};

const tr_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}. Ç`)
};

const it_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Q${i?.n}`)
};

const pl_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`K${i?.n}`)
};

const uk_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ч${i?.n}`)
};

const hi_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`क्यू${i?.n}`)
};

const ar_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ر${i?.n}`)
};

const ms_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`S${i?.n}`)
};

const bn_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`কো${i?.n}`)
};

const zh_tw2_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第${i?.n}節`)
};

const zh_hk2_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第${i?.n}節`)
};

const ur_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ک${i?.n}`)
};

const fa_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ک${i?.n}`)
};

const sw_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`R${i?.n}`)
};

const nl_quarter_short = /** @type {(inputs: Quarter_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`P${i?.n}`)
};

/**
* | output |
* | --- |
* | "Q{n}" |
*
* @param {Quarter_ShortInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const quarter_short = /** @type {((inputs: Quarter_ShortInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quarter_ShortInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_quarter_short(inputs)
	if (locale === "ja") return ja_quarter_short(inputs)
	if (locale === "zh") return zh_quarter_short(inputs)
	if (locale === "es") return es_quarter_short(inputs)
	if (locale === "pt") return pt_quarter_short(inputs)
	if (locale === "id") return id_quarter_short(inputs)
	if (locale === "fr") return fr_quarter_short(inputs)
	if (locale === "tl") return tl_quarter_short(inputs)
	if (locale === "vi") return vi_quarter_short(inputs)
	if (locale === "ko") return ko_quarter_short(inputs)
	if (locale === "de") return de_quarter_short(inputs)
	if (locale === "ru") return ru_quarter_short(inputs)
	if (locale === "tr") return tr_quarter_short(inputs)
	if (locale === "it") return it_quarter_short(inputs)
	if (locale === "pl") return pl_quarter_short(inputs)
	if (locale === "uk") return uk_quarter_short(inputs)
	if (locale === "hi") return hi_quarter_short(inputs)
	if (locale === "ar") return ar_quarter_short(inputs)
	if (locale === "ms") return ms_quarter_short(inputs)
	if (locale === "bn") return bn_quarter_short(inputs)
	if (locale === "zh-TW") return zh_tw2_quarter_short(inputs)
	if (locale === "zh-HK") return zh_hk2_quarter_short(inputs)
	if (locale === "ur") return ur_quarter_short(inputs)
	if (locale === "fa") return fa_quarter_short(inputs)
	if (locale === "sw") return sw_quarter_short(inputs)
	if (locale === "nl") return nl_quarter_short(inputs)
	return en_quarter_short(inputs)
});